<template>
    <div component="VideoProjectItemText">
        <header @click="open" :class="{ isOpen }">
            <btn size="iconSmall" color="transparent" :icon="isOpen ? 'remove' : 'add'" />
            <div class="label">{{ type }}</div>
        </header>
        <transition v-on:enter="enter" v-on:leave="leave">
            <footer v-if="isOpen">{{ videoRequest[type] }}</footer>
        </transition>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'VideoProjectItemText',

    props: {
        videoRequest: {
            type: Object,
            required: true,
        },

        type: {
            type: String,
            required: true,
            default: 'text',
        },
    },

    data() {
        return {};
    },

    computed: {
        ...mapGetters(['getActorVideoRequestSelectedSection']),

        isOpen() {
            return this.getActorVideoRequestSelectedSection === this.type;
        },
    },

    methods: {
        ...mapMutations(['setActorVideoRequestSelectedSection']),

        enter(el, done) {
            Velocity(el, 'slideDown', { duration: 300, easing: 'easeInBack' }, { complete: done });
        },

        leave(el, done) {
            Velocity(el, 'slideUp', { duration: 300, easing: 'easeInBack' }, { complete: done });
        },

        open() {
            const type = this.isOpen ? null : this.type;
            this.setActorVideoRequestSelectedSection(type);
        },
    },

    components: {},
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='VideoProjectItemText'] {
    .border-b;

    &:last-child {
        border-width: 0;
    }

    header {
        display: flex;
        align-items: center;
        font-weight: 900;
        cursor: pointer;
        padding: 5px 10px;
        border-bottom: 1px solid transparent;

        &.isOpen {
            background: fade(@black, 3%);
            border-color: @border;
        }

        .label {
            &:first-letter {
                text-transform: uppercase;
            }
        }

        button {
            margin-right: 10px;
        }
    }

    footer {
        padding: 10px 15px 10px 45px;
    }
}
</style>
